export function notificationCounter(value,max=99){
 const n=Number(value),count=Number.isFinite(n)?Math.max(0,Math.floor(n)):0;
 return {count,visible:count>0,text:count>max?`${max}+`:String(count)};
}
